<template>
  <div class="hero">
    <div class="container">
      <div class="hero__wrapper">
        <div class="hero__left">
          <h1 class="hero__title">{{ t('home.hero.title') }}</h1>
          <p class="hero__subtitle">{{ t('home.hero.subtitle') }}</p>
          <form class="hero__form" @submit.prevent="search">
            <input
                class="header__form-input"
                :placeholder="t('fields.headerSearch')"
                v-model="searchInput"
            />
          </form>
          <base-menu :categories="categories" :isActive="isMenuActive" @close-modal="handleCloseModal" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import BaseMenu from "@/components/base/base-menu.vue";
import {ref} from "vue";
import {useRouter} from "vue-router";

const router = useRouter()

const isMenuActive = ref(false)
const handleCloseModal = () => {
  isMenuActive.value = false;
}

const searchInput = ref('')
const search = () => {
  router.push({
    name: 'search',
    params: {
      searchQuery: searchInput.value,
      locale: localStorage.getItem('digitgiftcode-user-locale') || 'en-gb'
    }
  })
}
const {t} = useI18n()
</script>

<style lang="scss" scoped>
.hero {
  background-image: url("@images/heroBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;

  &__wrapper {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__left {
    display: flex;
    flex-direction: column;
    padding: 70px;
    align-items: center;
    justify-content: center;
  }

  &__image {
    width: 550px;
    position: absolute;
    right: 0;
    top: 0;
  }

  &__title {
    color: #3B3B3B;
    font-size: 63px;
    font-weight: 800;
    line-height: 51px;
  }

  &__subtitle {
    margin-block: 20px 30px;
    color: #3B3B3B;
    font-size: 30px;
    font-weight: 600;
    line-height: 51px;
    max-width: 500px;
    text-align: center;
  }

  &__form {
    background-image: url("@icons/search.svg");
    background-repeat: no-repeat;
    background-position: left 25px top 50%;
    background-color: #FFFFFF;
    border: #6D79E2 solid 1px;
    border-radius: 30px;
    padding: 13px 10px 13px 46px;

    width: 450px;

    & input{
      width: 100%;
    }
  }
}

@media (max-width: 1300px) {
  .hero {
    &__left {
      padding: 40px;
    }

    &__title {
      font-size: 42px;
    }

    &__subtitle {
      margin-top: 0;
      font-size: 24px;
    }

    &__text {
      margin-block: 50px 15px;
    }

    &__image {
      width: 350px;
    }
  }
}

@media (max-width: 1100px) {
  .hero {
    background-size: unset;
    margin-top: -200px;

    &__wrapper{
      margin-top: -200px;
    }
  }
}

@media (max-width: 750px) {
  .hero {
    margin-top: 100px;
    &__left {
      padding: unset;
    }
    &__wrapper {
      justify-content: center;
    }

    &__title{
      font-size: 36px;
      white-space: nowrap;
    }

    &__subtitle {
      font-size: 24px;
    }

    &__form{
      width: 300px;
    }

    &__image {
      display: none;
    }
  }
}
</style>